export const filterCriteria = [
    {
      label: "UoM Name",
      code: "name",
      field: { type: "input", label: "UoM Name" },
      isPartial: true,
    },
    {
      label: "Quantity Type",
      code: "quantityType",
      field: { type: "input", label: "Quantity Type" },
      isPartial: true,
    },
  ];

  export const searchColumnHeaders = [
    {
      id: "select",
      type: "button",
      action: "selectItem",
      position: "sticky",
      iconName: "hand-pointer",
      ariaLabel: "Open",
    },
    {
        title: "UoM Name",
        id: "name",
    },
    {
        title: "UoM Abbreviaion",
        id: "abbreviation",
    },
    {
        title: "Quantity Type",
        id: "quantityType",
    },
  ];

  export const defaultStateUnitOfMeasure = {
    _id: "NEW",
    name: "",
    abbreviation: "",
  };